const KEYBOARD_NAVIGATION_KEYS = new Set([
  'Tab',
  'Enter',
  ' ',
  'Escape',
  'ArrowUp',
  'ArrowRight',
  'ArrowDown',
  'ArrowLeft',
  'Home',
  'End',
  'PageUp',
  'PageDown',
]);

const root = document.documentElement;

document.addEventListener(
  'pointerdown',
  () => {
    root.dataset.focusModality = 'pointer';
  },
  { capture: true },
);

document.addEventListener(
  'keydown',
  (event) => {
    if (KEYBOARD_NAVIGATION_KEYS.has(event.key)) {
      root.dataset.focusModality = 'keyboard';
    }
  },
  { capture: true },
);
